import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!this.userService.hasRolesAssigned()) {
      this.router.navigate(['error'], {
        queryParams: {
          message:
            'Usted no tiene permiso para ingresar a DWHO. Por favor, gestione el acceso mediante el sistema de gestión de identidades.',
        },
      });
      return false;
    } else if (!this.userService.hasOnlyOneOperationalArea()) {
      this.router.navigate(['error'], {
        queryParams: {
          message:
            'Usted se encuentra asociado a más de un área operacional. Por favor, contacte al equipo de soporte de DWHO HHelpDWHO@pan-energy.com para regularizar su situación.',
        },
      });
      return false;
    }
    return true;
  }
}
